import React from "react";
import { Route, Routes } from "react-router";
import Home from "../pages/home/index";
import News from "pages/news";
import { OrganizationalStructureDetailsFactory } from "pages/organizationalStructureDetails/organizational-structure-details-factory";
import Error from "pages/errorPage";
import { ServicesFactory } from "pages/servicesPage/services-factory";
import { NewsFactory } from "pages/news/news-factory";
import { PublicationsFactory } from "pages/publications/publication-factory";
import Acessibility from "pages/acessibility";
import { OrganizationalStructureFactory } from "pages/organizationalStructure/organizational-structure-factory";
import { NewsDetailsFactory } from "pages/newDetails/news-details-factory";
import { CustomPage } from "pages/customPage/custom-page.page";
import { SearchResultsPage } from "pages/searchResults/searchResults.page";
import { LicitacoesFactory } from "pages/licitacoes/licitacoes-factory";
import { LicitacaoDetailsFactory } from "pages/licitacaoDetails/licitacao-details-factory";
import { ConveniosFactory } from "pages/convenios/convenios-factory";
import { ConvenioDetailsFactory } from "pages/convenioDetails/convenio-details-factory";
import { EmendasParlamentaresFactory } from "pages/emendasParlamentares/emendas-parlamentares-factory";
import { EmendaParlamentarDetailsFactory } from "pages/emendaParlamentarDetails/emenda-parlamentar-details-factory";
import { ContratosFactory } from "pages/contratos/contratos-factory";
import { ContratoDetailsFactory } from "pages/contratoDetails/contrato-details-factory";
import { ObrasFactory } from "pages/obras/obras-factory";
import { ObraDetailsFactory } from "pages/obraDetails/obra-details-factory";
import { SiteMapPage } from "pages/siteMap/site-map.page";
import { PrestacaoContasFactory } from "pages/prestacaoContas/prestacao-contas-factory";
import { PrestacaoContasTiposFactory } from "pages/prestacaoContas/prestacao-contas-tipos-factory";
import { PrestacaoContasDetailsFactory } from "pages/prestacaoContasDetails/prestacao-contas-details-factory";
import { DocumentosSetoriaisFactory } from "pages/documentosSetoriais/documentos-setoriais-factory";
import { DocumentoSetorialDetailsFactory } from "pages/documentoSetorialDetails/documento-setorial-details-factory";
import { RepassesSetoriaisFactory } from "pages/repassesSetoriais/repasses-setoriais-factory";
import { RepasseSetorialDetailsFactory } from "pages/repasseSetorialDetails/repasse-setorial-details-factory";
import { ConselhosFactory } from "pages/conselhos/conselhos-factory";
import { ConselhoDetailsFactory } from "pages/conselhoDetails/conselho-details-factory";
import { EstoquesMedicamentoFactory } from "pages/estoquesMedicamento/estoques-medicamento-factory";
import { FilasEsperaFactory } from "pages/filasEspera/filas-espera-factory";


export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/noticias" element={<NewsFactory />} />
      <Route path="/noticias/:id" element={<NewsDetailsFactory />} />
      <Route path="/servicos" element={<ServicesFactory />} />
      <Route path="/acessibilidade" element={<Acessibility />} />
      <Route
        path="/estrutura-organizacional"
        element={<OrganizationalStructureFactory />}
      />
      <Route path="/estrutura-organizacional/:id" element={<OrganizationalStructureDetailsFactory />} />
      <Route path="/publicacoes/:tab" element={<PublicationsFactory />} />
      <Route path="/pagina/:slug" element={<CustomPage />} />
      <Route path="/busca" element={<SearchResultsPage />} />
      <Route path="/mapa-do-site" element={<SiteMapPage />} />
      <Route path="/licitacoes" element={<LicitacoesFactory />} />
      <Route path="/licitacoes/:id" element={<LicitacaoDetailsFactory />} />
      <Route path="/convenios" element={<ConveniosFactory />} />
      <Route path="/convenios/:id" element={<ConvenioDetailsFactory />} />
      <Route path="/emendas-parlamentares" element={<EmendasParlamentaresFactory />} />
      <Route path="/emendas-parlamentares/:id" element={<EmendaParlamentarDetailsFactory />} />
      <Route path="/contratos" element={<ContratosFactory />} />
      <Route path="/contratos/:id" element={<ContratoDetailsFactory />} />
      <Route path="/obras" element={<ObrasFactory />} />
      <Route path="/obras/:id" element={<ObraDetailsFactory />} />
      <Route path="/prestacao-contas" element={<PrestacaoContasTiposFactory />} />
      <Route path="/prestacao-contas/tipo/:tipoId" element={<PrestacaoContasFactory />} />
      <Route path="/prestacao-contas/:id" element={<PrestacaoContasDetailsFactory />} />
      <Route path="/documentos-setoriais" element={<DocumentosSetoriaisFactory />} />
      <Route path="/documentos-setoriais/area/:areaSlug" element={<DocumentosSetoriaisFactory />} />
      <Route path="/documentos-setoriais/:id" element={<DocumentoSetorialDetailsFactory />} />
      <Route path="/repasses-setoriais" element={<RepassesSetoriaisFactory />} />
      <Route path="/repasses-setoriais/:id" element={<RepasseSetorialDetailsFactory />} />
      <Route path="/conselhos" element={<ConselhosFactory />} />
      <Route path="/conselhos/:id" element={<ConselhoDetailsFactory />} />
      <Route path="/estoques-medicamento" element={<EstoquesMedicamentoFactory />} />
      <Route path="/filas-espera" element={<FilasEsperaFactory />} />
      <Route path="*" element={<Error />} />
    </Routes>
  );
}
